import { TokenHistoryLabel } from "kadow-jetpack-model";

export function displaySocialLink(cta: TokenHistoryLabel) {
  switch (cta) {
    case TokenHistoryLabel.Instagram:
    case TokenHistoryLabel.IGStory:
      return "instagram.com/";

    case TokenHistoryLabel.Facebook:
      return "facebook.com/";

    case TokenHistoryLabel.TikTok:
      return "tiktok.com/@";

    case TokenHistoryLabel.SnapChat:
      return "snapchat.com/";

    default:
      return "";
  }
}
